import { ModalReactionsListContainer } from "../ReactionsList.styles";
import { reactions } from "@infrastructure/Persistence/Reactions";
import React, { useEffect, useState } from "react";
import { ModalReactionToggleButton } from "../Reaction.styles";
import { GetReactionIcon } from "../ReactionsIconsFactory";
import {
    UserLoginActionState,
    useUserStore,
} from "@infrastructure/Persistence/UserState";
import { ReactionsNamesEnum } from "../../../../Types/Reactions/ReactionsNamesEnum";
import { getUserReactionOnObject } from "@infrastructure/Hooks/UserInteractions/useUserReactions";
import { ReactionableObjectEnum } from "@infrastructure/Hooks/UserInteractions/UserInteractions.types";

export function ModalReactionsList({
    commentId,
    reactOnEntity,
    closeModal,
}: {
    closeModal: () => void;
    commentId: string;
    reactOnEntity: (reactionTypeName: string, action: string) => void;
}) {
    const [userReactions, setUserReactions] = useState<string[]>([]);
    useEffect(() => {
        const userReaction = getUserReactionOnObject(
            commentId.toString(),
            ReactionableObjectEnum.COMMENT,
        );

        if (userReaction) {
            setUserReactions([userReaction]);
        }
    }, [commentId]);

    const { setUserAuthContextState } = useUserStore();
    const changeSelectedReactions = (
        event: React.MouseEvent<HTMLElement>,
        newFormats: string[],
    ) => {
        setUserReactions(newFormats);
    };

    return (
        <ModalReactionsListContainer
            value={userReactions}
            onChange={changeSelectedReactions}
        >
            {reactions.map((reaction, key) => {
                if (
                    reaction.name !== ReactionsNamesEnum.LIKE &&
                    reaction.name !== ReactionsNamesEnum.DISLIKE
                ) {
                    return null;
                }
                const reactionName = reaction.name;
                const active = userReactions.includes(reactionName);
                const onReactionClicked = () => {
                    const action = active ? "delete" : "create";
                    reactOnEntity(reactionName, action);
                    closeModal();
                };
                return (
                    <ModalReactionToggleButton
                        key={key}
                        onClick={(e) => {
                            e.preventDefault();
                            setUserAuthContextState(
                                UserLoginActionState.CREATE_REACTION,
                            );
                            onReactionClicked();
                        }}
                        sx={{ borderLeft: "none" }}
                        value={reactionName}
                    >
                        <GetReactionIcon reactionName={reactionName} />
                    </ModalReactionToggleButton>
                );
            })}
        </ModalReactionsListContainer>
    );
}
